/**
 * I5 launch-stage namespace (R9 site audit, R10 launch kit, R14 waitlist,
 * R19 build in public). Each feature owns its own file so parallel work never
 * edits the shared fr/en/ar catalogs; those only spread `i5` in once.
 *
 * Every feature keeps one file per locale (`<feature>/fr.ts` is the source;
 * `en` / `ar` are typed against it), so a missing or extra key fails `tsc`
 * exactly like the root catalogs — and each locale bundles into its own chunk.
 */

import type { I5Catalog } from './fr';
import siteAudit from './siteAudit/en';
import launchKit from './launchKit/en';
import waitlist from './waitlist/en';
import bip from './bip/en';

const nav: I5Catalog['nav'] = {
  siteAudit: 'Site audit',
  launchKit: 'Launch kit',
};

export const i5En: I5Catalog = {
  nav,
  siteAudit,
  launchKit,
  waitlist,
  bip,
};
